import vue from 'vue'
import store from '@/store'
const that = vue.prototype
export default {
  // 车间
  className: 'shopManagement',
  fields: [
    {
      name: 'name',
      note: '车间名称',
      validators: [
        (val) => val ? null : '车间名称不可为空'
      ]
    },
    {
      name: 'amountRatio1',
      note: '车间吨系数',
      validators: [
        (val) => val ? null : '车间吨系数不可为空'
      ]
    },
    {
      name: 'profitRatio1',
      note: '车间利系数',
      validators: [
        (val) => val ? null : '车间利系数不可为空'
      ]
    }
  ],
  search: [
    'name'
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'workShop'
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
    },
    beforeSave ({ data }) {
      data.type = 'workShop'
    },
    async afterInsert ({ result }) {
      await that.$modelAjax.put('shopManagement', result.objectId, {
        workShop: result.objectId
      }).catch(e => { })
    }
  },
  action: {
    create: store.state.user && store.state.user.authority.workShop.create
      ? {} : false,
    edit: store.state.user && store.state.user.authority.workShop.edit ? {} : false,
    delete: false
  }
}
